import imigrationReport from './imigrationReport';
import reservationReport from './reservationReport';
import extrachargeReport from './extrachargeReport';
import roomSoldReport from './roomSoldReport';

export default [
    ...imigrationReport,
    ...reservationReport,
    ...extrachargeReport,
    ...roomSoldReport,
]